import { getCSSVariableValue } from '../../util';

const RAINBOW_GRADIENT_STOPS = [
  { offset: 0, cssVariable: '--ixf-color-primary-md', fallback: '#35C8CD' },
  { offset: 0.25, cssVariable: '--ixf-color-tertiary-md', fallback: '#648DD9' },
  { offset: 0.5, cssVariable: '--ixf-color-secondary-md', fallback: '#A639EA' },
  { offset: 0.75, cssVariable: '--ixf-color-quaternary-md', fallback: '#C43BB1' },
  { offset: 1, cssVariable: '--ixf-color-danger-md', fallback: '#FD9699' },
] as const;

function addRainbowGradientStops(gradient: CanvasGradient) {
  for (const { offset, cssVariable, fallback } of RAINBOW_GRADIENT_STOPS) {
    gradient.addColorStop(offset, getCSSVariableValue(cssVariable) || fallback);
  }

  return gradient;
}

export function getRainbowLinearGradient(ctx: CanvasRenderingContext2D, fromX: number, toX: number) {
  return addRainbowGradientStops(ctx.createLinearGradient(fromX, 0, toX, 0));
}

export function getRainbowVerticalLinearGradient(ctx: CanvasRenderingContext2D, fromY: number, toY: number) {
  return addRainbowGradientStops(ctx.createLinearGradient(0, fromY, 0, toY));
}
